"use strict";

import React, {Component} from "react";
import "react-table/react-table.css";

import Tabs from "../../component/Widget/Tabs";
import Section from "../../component/Template/Section";
import EnrichedVideoTable from "../../component/EnrichedVideo/Widget/EnrichedVideoTable";

import {getRequest} from "../../service/api/request";

import {apiPath} from "../../const";

const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;


class EnrichedVideosByProgram extends Component {

    static defaultProps = {
        defaultPageSize: 20,
        defaultSorted: [{id: "lastModifiedDate", desc: true}],
        defaultSortDesc: true,
    };

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            origData: [],
            search: '',
            filtered: [],
            loading: true,
            programId: this.props.match.params.programId,
        };
        this.onChangeSearch = this.onChangeSearch.bind(this);
    }

    componentWillMount() {
        this.searchTimeoutHandle = 0;
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.match.params.programId !== this.props.match.params.programId) {
            const programId = this.props.match.params.programId;
            this.setState({ programId });
            this.fetchData();
        }
    }

    fetchData() {
        this.setState({ loading: true });

        const reportApiPath = apiPath + "/enrichedVideos/search/findAllByProgram_Id";
        let params = {};
        params.programId = this.state.programId;

        getRequest(
            reportApiPath,
            params
        ).then(response => {
            this.setState({
                data: response.entity._embedded.enrichedVideos,
                origData: response.entity._embedded.enrichedVideos,
                loading: false,
            });
        });
    }

    onChangeSearch(e) {
        const self = this;

        if (self.searchTimeoutHandle) {
            clearTimeout(self.searchTimeoutHandle);
        }

        const { value } = e.target;
        const search = value;
        this.setState({ search });

        self.searchTimeoutHandle = setTimeout(() => self.triggerSearch(value), WAIT_INTERVAL)
    }

    onKeyDownSearch(e) {
        if (e.keyCode === ENTER_KEY) {
            this.triggerSearch(this.state.search);
        }
    }

    triggerSearch(value) {
        const search = value.toLowerCase();
        const filtered = value
                         ? [
                             { id: 'videoMetaId', value: value },
                             { id: 'title', value: value },
                             { id: 'programId', value: value },
                             { id: 'seriesId', value: value },
                             { id: 'seasonId', value: value },
                             { id: 'programTitle', value: value },
                             { id: 'slug', value: value },
                             { id: 'genRef', value: value },
                             { id: 'uid', value: value },
                             { id: 'regionCode', value: value },
                           ]
                         : [];

        const data = {};
        const origData = this.state.origData;
        Object.keys(origData).forEach(violation => {
            let enrichedVideos = origData[violation];
            data[violation] = enrichedVideos.filter( e => this.enrichedVideoMatch(e, search));
        });
        this.setState({ data, filtered });
    }

    enrichedVideoMatch(e, search) {
        return ((e.videoMetaId || "").toLowerCase().indexOf(search) !== -1) ||
               ((e.title || "").toLowerCase().indexOf(search) !== -1) ||
               ((e.programId || "").toLowerCase().indexOf(search) !== -1) ||
               ((e.seriesId || "").toLowerCase().indexOf(search) !== -1) ||
               ((e.seasonId || "").toLowerCase().indexOf(search) !== -1) ||
               ((e.programTitle || "").toLowerCase().indexOf(search) !== -1) ||
               ((e.slug || "").toLowerCase().indexOf(search) !== -1) ||
               ((e.genRef || "").toLowerCase().indexOf(search) !== -1) ||
               ((e.uid || "").toLowerCase().indexOf(search) !== -1) ||
               ((e.regionCode || "").toLowerCase().indexOf(search) !== -1);
    }

    render() {
        const { data, search, filtered, loading, violationLevel } = this.state;
        const { defaultPageSize, defaultSorted, defaultSortDesc } = this.props;

        return (
            <div>
                <Section className="content-header">
                    <h1>Program Enriched Videos <small>{this.renderProgramHeader(data)}</small></h1>
                </Section>
                <Section className="content">
                    <div className="form-group">
                        <input id="search" type="text" className="form-control" placeholder="Search..."
                               value={search} onChange={this.onChangeSearch} onKeyDown={this.onKeyDownSearch} />
                    </div>
                    <EnrichedVideoTable
                        loading={loading} // Display the loading overlay when we need it
                        data={data}
                        defaultPageSize={defaultPageSize}
                        defaultSorted={defaultSorted}
                        defaultSortDesc={defaultSortDesc}
                    />
                </Section>
            </div>
        );
    }

    renderProgramHeader(enrichedVideos) {
        return enrichedVideos && enrichedVideos[0] && enrichedVideos[0].programTitle
               ? enrichedVideos[0].programTitle
               : '';
    }

}

export default EnrichedVideosByProgram;
